var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#g';
                    var viewUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '137.718 -1.001 366.563 644',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };